module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMSIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDExIDExIj4NCiAgICA8cGF0aCBmaWxsPSIjMzMzMzNEIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjQ2MyAxLjU4OEwxMC40NSA1LjUgNC40NjMgOS40MTJ6Ii8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chat-user-flow-pointer.svg
// module id = zsfH
// module chunks = 1